import React, { useState } from "react";
import { Modal, Card, Radio, Space, Typography } from "antd";
import { BankOutlined } from "@ant-design/icons";

const { Text } = Typography;

interface Business {
  name: string;
  businessId: number;
  accountId: string;
}

interface BusinessSelectorProps {
  isOpen: boolean;
  onClose: () => void;
  onSelect: (business: Business) => void;
  businesses: any;
}

const BusinessSelector: React.FC<BusinessSelectorProps> = ({
  isOpen,
  onClose,
  onSelect,
  businesses,
}) => {
  const [selectedBusiness, setSelectedBusiness] = useState<Business | null>(
    null
  );

  console.log("businesses", businesses);
  
  const handleOk = () => {
    if (selectedBusiness) {
      onSelect(selectedBusiness);
      onClose();
    }
  };

  const handleBusinessSelect = (business: Business) => {
    setSelectedBusiness(business);
  };

  return (
    <Modal
      title="Select Business"
      open={isOpen}
      onOk={handleOk}
      onCancel={onClose}
      okButtonProps={{ disabled: !selectedBusiness }}
      width={800}
    >
      <Radio.Group
        onChange={(e) => handleBusinessSelect(e.target.value)}
        value={selectedBusiness}
        style={{ width: "100%" }}
      >
        <Space direction="vertical" style={{ width: "100%" }}>
          {businesses.map((business: any) => (
            <Card
              key={business.businessId}
              hoverable
              style={{
                width: "100%",
                borderColor:
                  selectedBusiness?.businessId === business.businessId
                    ? "#1890ff"
                    : undefined,
                cursor: "pointer",
              }}
              onClick={() => handleBusinessSelect(business)}
            >
              <Radio value={business} style={{ width: "100%" }}>
                <Space align="start">
                  <BankOutlined
                    style={{ fontSize: "24px", color: "#1890ff" }}
                  />
                  <Space direction="vertical" size={0}>
                    <Text strong>{business.name}</Text>
                  </Space>
                </Space>
              </Radio>
            </Card>
          ))}
        </Space>
      </Radio.Group>
    </Modal>
  );
};

export default BusinessSelector;
